document.addEventListener("click", function (e) {
  if (
    e.target.dataset.action == "size-guide" ||
    e.target.closest("[data-action='size-guide']")
  ) {
    toggleSizeGuide();
  }
});
function toggleSizeGuide() {
  let sizeGuide = document.querySelector("[data-role='sizeGuide']");
  let dis = getComputedStyle(sizeGuide).display;

  if (dis == "none") {
    sizeGuide.style.display = "block";
    document.body.style.overflowY = "hidden";
    setTimeout(() => {
      sizeGuide.style.opacity = "1";
    }, 0);
  } else {
    sizeGuide.style.opacity = "0";
    document.body.style.overflowY = "auto";
    setTimeout(() => {
      sizeGuide.style.display = "none";
    }, 0);
  }
}
